import React, { useState } from 'react';
import './App.css';

function App() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    business: '',
    message: ''
  });

  const [formSubmitted, setFormSubmitted] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Aqui você implementaria a lógica para enviar os dados para seu backend/email
    console.log('Formulário enviado:', formData);
    setFormSubmitted(true);
    // Reset form after submission
    setFormData({
      name: '',
      email: '',
      phone: '',
      business: '',
      message: ''
    });
    // Mostrar mensagem de sucesso por 3 segundos
    setTimeout(() => setFormSubmitted(false), 3000);
  };

  return (
    <div className="App">
      <header className="header">
        <div className="container">
          <div className="logo">
            <h1>SEO Local Pro</h1>
          </div>
          <nav className="main-nav">
            <ul>
              <li><a href="#home">Início</a></li>
              <li><a href="#services">Serviços</a></li>
              <li><a href="#results">Resultados</a></li>
              <li><a href="#portfolio">Portfólio</a></li>
              <li><a href="#about">Sobre</a></li>
              <li><a href="#contact" className="btn-primary">Fale Conosco</a></li>
            </ul>
          </nav>
        </div>
      </header>

      <section id="home" className="hero">
        <div className="container">
          <div className="hero-content">
            <h1>Aumente sua visibilidade local e conquiste mais clientes</h1>
            <p>Especialistas em SEO Local que aumentam seu posicionamento no Google Maps e buscas locais</p>
            <div className="cta-buttons">
              <a href="#contact" className="btn-primary">Análise Gratuita</a>
              <a href="#services" className="btn-secondary">Conheça Nossos Serviços</a>
            </div>
            <div className="hero-stats">
              <div className="stat">
                <span className="stat-number">93%</span>
                <span className="stat-desc">dos clientes encontram negócios locais pelo Google</span>
              </div>
              <div className="stat">
                <span className="stat-number">75%</span>
                <span className="stat-desc">dos usuários não passam da primeira página</span>
              </div>
              <div className="stat">
                <span className="stat-number">28%</span>
                <span className="stat-desc">das buscas locais resultam em compra</span>
              </div>
            </div>
          </div>
          <div className="hero-image">
            <img src="https://via.placeholder.com/600x400" alt="Dashboard de SEO mostrando crescimento de tráfego local" />
          </div>
        </div>
      </section>

      <section id="benefits" className="benefits">
        <div className="container">
          <h2>Por que investir em SEO Local?</h2>
          <div className="benefits-grid">
            <div className="benefit-card">
              <img src="https://via.placeholder.com/80" alt="Ícone de alvo com flecha" />
              <h3>Clientes Qualificados</h3>
              <p>Atraia pessoas que já estão procurando por seus produtos ou serviços na sua região</p>
            </div>
            <div className="benefit-card">
              <img src="https://via.placeholder.com/80" alt="Ícone de gráfico crescente" />
              <h3>Aumento de Vendas</h3>
              <p>Visitantes de busca local têm 28% mais chances de se tornarem clientes</p>
            </div>
            <div className="benefit-card">
              <img src="https://via.placeholder.com/80" alt="Ícone de medalha" />
              <h3>Vantagem Competitiva</h3>
              <p>Destaque-se dos concorrentes conquistando as primeiras posições nas buscas locais</p>
            </div>
            <div className="benefit-card">
              <img src="https://via.placeholder.com/80" alt="Ícone de retorno sobre investimento" />
              <h3>Melhor ROI</h3>
              <p>SEO local oferece maior retorno sobre investimento que anúncios pagos a longo prazo</p>
            </div>
          </div>
        </div>
      </section>

      <section id="services" className="services">
        <div className="container">
          <h2>Nossos Serviços de SEO Local</h2>
          <p className="section-description">Soluções personalizadas para aumentar sua visibilidade nas buscas locais</p>
          
          <div className="services-grid">
            <div className="service-card">
              <img src="https://via.placeholder.com/100" alt="Ícone de Google Meu Negócio" />
              <h3>Otimização do Google Meu Negócio</h3>
              <p>Configuração completa e otimização da sua ficha no Google Maps para atrair mais clientes locais</p>
              <ul>
                <li>Cadastro e verificação completos</li>
                <li>Otimização de informações e categorias</li>
                <li>Estratégia de fotos e conteúdo visual</li>
                <li>Gestão de avaliações e respostas</li>
              </ul>
            </div>
            
            <div className="service-card">
              <img src="https://via.placeholder.com/100" alt="Ícone de mapa com marcador" />
              <h3>SEO Local para Website</h3>
              <p>Otimização técnica do seu site para aparecer nas buscas por serviços em sua região</p>
              <ul>
                <li>Otimização de palavras-chave locais</li>
                <li>Criação de páginas locais otimizadas</li>
                <li>Implementação de schema markup local</li>
                <li>Otimização para mobile e velocidade</li>
              </ul>
            </div>
            
            <div className="service-card">
              <img src="https://via.placeholder.com/100" alt="Ícone de construção de links" />
              <h3>Construção de Citações Locais</h3>
              <p>Aumento da sua autoridade local através de citações e referências em sites relevantes</p>
              <ul>
                <li>Criação de perfis em diretórios locais</li>
                <li>Correção de NAP inconsistente</li>
                <li>Obtenção de backlinks locais relevantes</li>
                <li>Monitoramento de citações e autoridade</li>
              </ul>
            </div>
            
            <div className="service-card">
              <img src="https://via.placeholder.com/100" alt="Ícone de conteúdo local" />
              <h3>Conteúdo Geolocalizado</h3>
              <p>Estratégia de conteúdo relevante para sua audiência local e otimizado para conversão</p>
              <ul>
                <li>Blog posts focados em interesse local</li>
                <li>Landing pages para cada região atendida</li>
                <li>Estudos de caso e depoimentos locais</li>
                <li>Otimização para eventos e sazonalidades</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section id="process" className="process">
        <div className="container">
          <h2>Como trabalhamos</h2>
          <div className="process-steps">
            <div className="process-step">
              <div className="step-number">1</div>
              <h3>Análise Inicial</h3>
              <p>Avaliamos sua presença online atual, concorrentes locais e oportunidades de palavras-chave específicas para sua região.</p>
            </div>
            <div className="process-step">
              <div className="step-number">2</div>
              <h3>Estratégia Personalizada</h3>
              <p>Criamos um plano de SEO local sob medida para seu negócio, com foco nos canais mais relevantes para seu público.</p>
            </div>
            <div className="process-step">
              <div className="step-number">3</div>
              <h3>Implementação</h3>
              <p>Aplicamos as otimizações técnicas, criamos conteúdo geolocalizado e melhoramos sua presença em diretórios locais.</p>
            </div>
            <div className="process-step">
              <div className="step-number">4</div>
              <h3>Monitoramento e Ajustes</h3>
              <p>Acompanhamos os resultados com relatórios mensais e ajustamos a estratégia continuamente para maximizar o ROI.</p>
            </div>
          </div>
        </div>
      </section>

      <section id="results" className="results">
        <div className="container">
          <h2>Resultados que entregamos</h2>
          <div className="results-grid">
            <div className="result-card">
              <img src="https://via.placeholder.com/150" alt="Gráfico de crescimento de tráfego local" />
              <h3>Aumento de Tráfego Qualificado</h3>
              <p>Média de 65% de aumento em visitantes locais nos primeiros 3 meses</p>
            </div>
            <div className="result-card">
              <img src="https://via.placeholder.com/150" alt="Smartphone mostrando pesquisa no Google Maps" />
              <h3>Melhores Posições no Google Maps</h3>
              <p>93% dos nossos clientes aparecem no top 3 do Maps para suas principais palavras-chave</p>
            </div>
            <div className="result-card">
              <img src="https://via.placeholder.com/150" alt="Gráfico de conversões" />
              <h3>Mais Conversões</h3>
              <p>Aumento médio de 47% em leads e 32% em vendas após 6 meses</p>
            </div>
            <div className="result-card">
              <img src="https://via.placeholder.com/150" alt="Estrelas de avaliação" />
              <h3>Melhor Reputação Online</h3>
              <p>Aumento de 4.2 para 4.8 estrelas em média nas avaliações do Google</p>
            </div>
          </div>
        </div>
      </section>

      <section id="portfolio" className="portfolio">
        <div className="container">
          <h2>Portfólio e Casos de Sucesso</h2>
          <div className="portfolio-grid">
            <div className="portfolio-item">
              <img src="https://via.placeholder.com/350x250" alt="Dashboard de SEO para cliente SaaS" />
              <div className="portfolio-content">
                <h3>Cliente SaaS</h3>
                <p>Uma plataforma SaaS de gestão financeira que conquistou a primeira posição nas buscas locais em 12 cidades.</p>
                <ul>
                  <li>Aumento de 83% no tráfego local</li>
                  <li>Crescimento de 42% em leads qualificados</li>
                  <li>ROI de 320% após 6 meses</li>
                </ul>
                <a href="#" className="btn-secondary">Ver Caso Completo</a>
              </div>
            </div>
            
            <div className="portfolio-item">
              <img src="https://via.placeholder.com/350x250" alt="Gráfico de crescimento para cliente ONG" />
              <div className="portfolio-content">
                <h3>Cliente ONG</h3>
                <p>Uma organização sem fins lucrativos que aumentou em 76% o número de voluntários e doações através do SEO local.</p>
                <ul>
                  <li>Aumento de 94% na visibilidade no Google Maps</li>
                  <li>Crescimento de 76% em contatos via Google Meu Negócio</li>
                  <li>Aumento de 51% em doações online de origem local</li>
                </ul>
                <a href="#" className="btn-secondary">Ver Caso Completo</a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="testimonials" className="testimonials">
        <div className="container">
          <h2>O que nossos clientes dizem</h2>
          <div className="testimonials-grid">
            <div className="testimonial-card">
              <div className="testimonial-rating">★★★★★</div>
              <p className="testimonial-text">"Depois de 3 meses trabalhando com a equipe de SEO Local, nosso negócio aparece entre os 3 primeiros resultados do Google Maps. O número de clientes aumentou consideravelmente!"</p>
              <div className="testimonial-author">
                <img src="https://via.placeholder.com/60" alt="Foto de cliente" className="testimonial-image" />
                <div className="testimonial-info">
                  <h4>Roberto Silva</h4>
                  <p>Proprietário da RS Consultoria</p>
                </div>
              </div>
            </div>
            
            <div className="testimonial-card">
              <div className="testimonial-rating">★★★★★</div>
              <p className="testimonial-text">"O investimento em SEO local foi o melhor que fizemos este ano. Nossas ligações de clientes locais aumentaram 52% e nossa agenda está lotada!"</p>
              <div className="testimonial-author">
                <img src="https://via.placeholder.com/60" alt="Foto de cliente" className="testimonial-image" />
                <div className="testimonial-info">
                  <h4>Carla Mendes</h4>
                  <p>Gerente da Clínica Saúde Total</p>
                </div>
              </div>
            </div>
            
            <div className="testimonial-card">
              <div className="testimonial-rating">★★★★★</div>
              <p className="testimonial-text">"Antes do trabalho de SEO Local, quase não aparecíamos nas buscas da nossa cidade. Agora somos a primeira opção quando alguém procura por nossos serviços na região."</p>
              <div className="testimonial-author">
                <img src="https://via.placeholder.com/60" alt="Foto de cliente" className="testimonial-image" />
                <div className="testimonial-info">
                  <h4>André Fernandes</h4>
                  <p>Diretor da AF Arquitetura</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="cta" className="cta">
        <div className="container">
          <h2>Pronto para aumentar sua visibilidade local?</h2>
          <p>Solicite sua análise gratuita hoje e descubra como podemos ajudar seu negócio a se destacar nas buscas locais.</p>
          <a href="#contact" className="btn-primary">Quero uma análise gratuita</a>
        </div>
      </section>

      <section id="faq" className="faq">
        <div className="container">
          <h2>Perguntas Frequentes</h2>
          <div className="faq-grid">
            <div className="faq-item">
              <h3>Quanto tempo leva para ver resultados com SEO local?</h3>
              <p>Normalmente, os primeiros resultados começam a aparecer entre 30 e 90 dias, com melhorias significativas em 3-6 meses. O SEO local tende a trazer resultados mais rápidos que o SEO tradicional.</p>
            </div>
            
            <div className="faq-item">
              <h3>Quais tipos de negócios mais se beneficiam do SEO local?</h3>
              <p>Qualquer negócio que atenda clientes em uma área geográfica específica, como restaurantes, clínicas, escritórios de advocacia, lojas de varejo, prestadores de serviços domésticos, entre outros.</p>
            </div>
            
            <div className="faq-item">
              <h3>O SEO local funciona para várias localizações?</h3>
              <p>Sim! Temos estratégias específicas para negócios com múltiplas unidades ou que atendem diferentes regiões, garantindo visibilidade em cada área de atuação.</p>
            </div>
            
            <div className="faq-item">
              <h3>Como vocês medem o sucesso das campanhas de SEO local?</h3>
              <p>Utilizamos métricas como posições no Google Maps, tráfego de buscas locais, taxa de conversão, chamadas e direções solicitadas via Google Meu Negócio, entre outros KPIs relevantes.</p>
            </div>
            
            <div className="faq-item">
              <h3>O SEO local substitui a necessidade de anúncios pagos?</h3>
              <p>O SEO local e anúncios pagos são complementares. Enquanto o SEO traz resultados orgânicos de longo prazo, os anúncios podem gerar resultados imediatos. A estratégia ideal geralmente combina ambos.</p>
            </div>
            
            <div className="faq-item">
              <h3>Como vocês se mantêm atualizados com as mudanças do Google?</h3>
              <p>Nossa equipe está constantemente estudando e testando as atualizações dos algoritmos do Google, participando de eventos e fóruns do setor para garantir que nossas estratégias estejam sempre atualizadas.</p>
            </div>
          </div>
        </div>
      </section>

      <section id="contact" className="contact">
        <div className="container">
          <div className="contact-content">
            <div className="contact-info">
              <h2>Entre em Contato</h2>
              <p>Estamos prontos para ajudar seu negócio a se destacar nas buscas locais. Preencha o formulário ou use os dados abaixo para falar conosco.</p>
              
              <div className="contact-methods">
                <div className="contact-method">
                  <img src="https://via.placeholder.com/30" alt="Ícone de telefone" />
                  <span>(11) 9999-9999</span>
                </div>
                <div className="contact-method">
                  <img src="https://via.placeholder.com/30" alt="Ícone de email" />
                  <span>contato@seolocalpro.com.br</span>
                </div>
                <div className="contact-method">
                  <img src="https://via.placeholder.com/30" alt="Ícone de localização" />
                  <span>Rua Exemplo, 123 - São Paulo, SP</span>
                </div>
              </div>
              
              <div className="social-media">
                <a href="#" target="_blank" rel="noopener noreferrer">
                  <img src="https://via.placeholder.com/40" alt="Ícone do Facebook" />
                </a>
                <a href="#" target="_blank" rel="noopener noreferrer">
                  <img src="https://via.placeholder.com/40" alt="Ícone do Instagram" />
                </a>
                <a href="#" target="_blank" rel="noopener noreferrer">
                  <img src="https://via.placeholder.com/40" alt="Ícone do LinkedIn" />
                </a>
              </div>
            </div>
            
            <div className="contact-form">
              <h3>Solicite sua análise gratuita</h3>
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="name">Nome Completo*</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="email">E-mail*</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="phone">Telefone*</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="business">Nome do Negócio*</label>
                  <input
                    type="text"
                    id="business"
                    name="business"
                    value={formData.business}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="message">Conte-nos sobre seu negócio</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    rows="4"
                  ></textarea>
                </div>
                
                <button type="submit" className="btn-primary">Solicitar Análise Gratuita</button>
                
                {formSubmitted && (
                  <div className="form-success">
                    Mensagem enviada com sucesso! Entraremos em contato em breve.
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </section>

      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-logo">
              <h3>SEO Local Pro</h3>
              <p>Especialistas em visibilidade local para seu negócio</p>
            </div>
            
            <div className="footer-links">
              <div className="footer-links-column">
                <h4>Navegação</h4>
                <ul>
                  <li><a href="#home">Início</a></li>
                  <li><a href="#services">Serviços</a></li>
                  <li><a href="#results">Resultados</a></li>
                  <li><a href="#portfolio">Portfólio</a></li>
                  <li><a href="#about">Sobre</a></li>
                  <li><a href="#contact">Contato</a></li>
                </ul>
              </div>
              
              <div className="footer-links-column">
                <h4>Serviços</h4>
                <ul>
                  <li><a href="#services">Google Meu Negócio</a></li>
                  <li><a href="#services">SEO Local para Website</a></li>
                  <li><a href="#services">Construção de Citações</a></li>
                  <li><a href="#services">Conteúdo Geolocalizado</a></li>
                </ul>
              </div>
              
              <div className="footer-links-column">
                <h4>Recursos</h4>
                <ul>
                  <li><a href="#">Blog</a></li>
                  <li><a href="#">Guia de SEO Local</a></li>
                  <li><a href="#">Estudos de Caso</a></li>
                  <li><a href="#">Webinars Gratuitos</a></li>
                </ul>
              </div>
            </div>
          </div>
          
          <div className="footer-bottom">
            <p>&copy; 2025 SEO Local Pro. Todos os direitos reservados.</p>
            <div className="footer-legal">
              <a href="#">Política de Privacidade</a>
              <a href="#">Termos de Uso</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;